/**
 * EM: Apply min/multiple from shop.metafields.custom.em_qty_map on variant change
 * and on quantity inputs that have no Liquid min/step yet (quick buy).
 */
const emQtyMap = () => window.themeVariables?.emQtyMap || {};

function emQtyRule(variantId) {
  if (variantId == null) return { min: 1, multiple: 1 };
  return emQtyMap()[String(variantId)] || { min: 1, multiple: 1 };
}

function emQtyHintText(min, step) {
  const strings = window.themeVariables?.strings || {};
  const parts = [];
  if (min > 1 && strings.emQtyMinimum) {
    parts.push(strings.emQtyMinimum.replace(/__MIN__/g, String(min)));
  }
  if (step > 1 && step !== min && strings.emQtyIncrement) {
    parts.push(strings.emQtyIncrement.replace(/__STEP__/g, String(step)));
  }
  return parts.join(", ");
}

function emQtyApply(input, rule) {
  if (!input || !rule) return;
  const min = Number(rule.min) || 1;
  const step = Number(rule.multiple) || 1;
  input.min = String(min);
  input.step = String(step);
  input.value = String(min);
  input.style.setProperty("--quantity-input-characters-count", `${String(min).length}ch`);
  if (typeof input.quantity === "number") {
    input.quantity = min;
  }
}

function emQtyForm(event) {
  const target = event.target;
  if (target instanceof HTMLFormElement) return target;
  return target?.closest?.("form") || null;
}

function emQtyInputs(form) {
  const formId = form?.getAttribute?.("id") || "";
  const found = new Set();
  if (formId) {
    document.querySelectorAll(`input[name="quantity"][form="${CSS.escape(formId)}"]`).forEach((input) => found.add(input));
  }
  if (form) {
    form.querySelectorAll('input[name="quantity"]').forEach((input) => found.add(input));
  }
  document.querySelectorAll("input.quantity-selector__input, input.quantity-input").forEach((input) => {
    if (!formId || input.getAttribute("form") === formId || (form && form.contains(input))) {
      found.add(input);
    }
  });
  return [...found];
}

function emQtyApplyHints(form, rule) {
  const min = Number(rule.min) || 1;
  const step = Number(rule.multiple) || 1;
  const text = emQtyHintText(min, step);
  const root = form?.closest("product-rerender") || form?.closest(".product-info") || document;
  root.querySelectorAll("[data-em-qty-hint]").forEach((hint) => {
    hint.textContent = text;
    hint.hidden = text === "";
  });
}

function emQtyApplyVariant(event) {
  const variant = event.detail?.variant;
  if (!variant?.id) return;
  const rule = emQtyRule(variant.id);
  const form = emQtyForm(event);
  emQtyInputs(form).forEach((input) => emQtyApply(input, rule));
  emQtyApplyHints(form, rule);
}

function emQtyOnVariantChange(event) {
  emQtyApplyVariant(event);
  requestAnimationFrame(() => emQtyApplyVariant(event));
}

document.addEventListener("variant:change", emQtyOnVariantChange);
